import { render, staticRenderFns } from "./EmpresaMultipla.vue?vue&type=template&id=47298bcc&"
import script from "./EmpresaMultipla.vue?vue&type=script&lang=js&"
export * from "./EmpresaMultipla.vue?vue&type=script&lang=js&"
import style0 from "./EmpresaMultipla.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports